import React from 'react';
import { FileDownload } from '@mui/icons-material';
import ActionMenu, { ActionMenuItemProps } from 'components/_atoms/ActionMenu';
import { translate as t } from 'hooks/useTranslations';
import { getLmsUrl } from 'data_sources/constants';

export const ExportReportMenu: React.FC = () => {
  const menuItems: ActionMenuItemProps[] = [
    {
      key: 'credit-hours',
      label: t('reporting.insightsCenter.training.actions.exportCreditHours'),
      href: getLmsUrl('/analytics/reports/new-report/members-report?groupBy=completion'),
    },
    {
      key: 'certificates',
      label: t('reporting.insightsCenter.training.actions.exportCertificates'),
      href: getLmsUrl('/analytics/reports/new-report/certificate-report?groupBy=default'),
    },
    {
      key: 'credentials',
      label: t('reporting.insightsCenter.training.actions.exportCredentials'),
      href: getLmsUrl('/analytics/reports/new-report/credentials-report?groupBy=default'),
    },
    {
      key: 'assignments',
      label: t('reporting.insightsCenter.training.actions.exportAssignments'),
      href: getLmsUrl('/analytics/reports/new-report/assignments-report?groupBy=default'),
    },
  ];

  return (
    <ActionMenu
      id='export-report-menu'
      btnText={t('reporting.insightsCenter.training.actions.export')}
      items={menuItems}
      btnProps={{
        startIcon: <FileDownload />,
        variant: 'contained',
        size: 'small',
      }}
    />
  );
};
